<template>
  <div style="min-height:95vh;">
    <div class="orderInfoTop">
      <div style="width:96%;margin:0 auto;">
        <div class="orderinfoTopOne">
          <div>{{dataObject.receiverName}}</div>
          <div style="margin-left:15px;">{{dataObject.receiverPhone}}</div>
        </div>
        <div style="color:#999999;" class="orderinfoTopTwo">
          {{dataObject.receiverAddrNameFull}}{{dataObject.receiverDetailAddress}}
        </div>
      </div>
      <div class="multiplexing"></div>
      <div class="orderinfoTopcenter">
        <div class="orderinfoTopcenterone" >
          <div v-if="dataObject.status==0">待付款</div>
          <div v-if="dataObject.status==1">待发货</div>
          <div v-if="dataObject.status==2">待收货</div>
          <div v-if="dataObject.status==3">待评价</div>
          <div v-if="dataObject.status==4">已完成</div>
          <div v-if="dataObject.status==5">已取消</div>
          <div v-if="dataObject.status==6">已关闭</div>
        </div>
        <!-- <div class="orderinfoTopcenterone" v-if="dataObject.afterStatus==1"><div>退款中</div></div>
        <div class="orderinfoTopcenterone" v-if="dataObject.afterStatus==2"><div>退款成功</div></div>
        <div class="orderinfoTopcenterone" v-if="dataObject.afterStatus==3">
          <div v-if="dataObject.status==0">待付款</div>
          <div v-if="dataObject.status==1">待发货</div>
          <div v-if="dataObject.status==2">待收货</div>
          <div v-if="dataObject.status==3">待评价</div>
          <div v-if="dataObject.status==4">已完成</div>
          <div v-if="dataObject.status==5">已取消</div>
          <div v-if="dataObject.status==6">已关闭</div>
        </div>
        <div class="orderinfoTopcenterone" v-if="dataObject.afterStatus==4">
          <div v-if="dataObject.status==0">待付款</div>
          <div v-if="dataObject.status==1">待发货</div>
          <div v-if="dataObject.status==2">待收货</div>
          <div v-if="dataObject.status==3">待评价</div>
          <div v-if="dataObject.status==4">已完成</div>
          <div v-if="dataObject.status==5">已取消</div>
          <div v-if="dataObject.status==6">已关闭</div>
        </div> -->
        <div class="orderinfoTopcentertwo">
          <dl v-for="(item,index) in dataObject.orderItemList" :key="index" @click="goCommodityDetails(item)">
            <dt style="float:left;"><img :src="item.productPic" alt=""></dt>
            <dd>
              <div class="orderinfoTopcentertwodd" style="display:flex;justify-content:space-between;color:#333333;">
                <div class="ellpis">
                  <span style="width:8%;margin-top:2%;" v-if="dataObject.supplierCode=='ZY'" class="ZY">自营</span>
                  <span style="padding-left:5px;">{{item.productName}}</span>
                </div>
                <div style="padding-right:10px;">x{{item.productQuantity}}</div>
              </div>
              <div class="orderinfoTopcentertwoddTwo">{{item.productAttr}}</div>
              <div class="orderinfoTopcentertwoddThree">
                <div style="display:flex;justify-content: space-between;">
                  <div style="color:#333333;">￥{{item.productPrice}}</div>
                  <s style="color:#ccc;margin-left:5px;">￥{{item.productOriginalPrice}}</s>
                </div>
                <div v-if="dataObject.status!=1 && dataObject.status<5 && dataObject.status!=0">
                  <!-- <template v-if="dataObject.status===2">
                    <button class="button" v-if="item.commentStatus===0 && item.statusReturn ===0" @click="orderEval(item,item.productId)">评价</button>
                  </template> -->
                  <template v-if="dataObject.status===3">
                    <button class="button" v-if="item.commentStatus===0 && item.statusReturn ===0" @click="orderEval(item,item.productId)">评价</button>
                  </template>
                  <template>
                    <button v-if="item.statusReturn===0" class="button margin_left" @click="orderSale(item)">申请售后</button>
                    <button v-else-if="item.statusReturn===1" class="buttonred margin_left"  @click="orderSpeed(dataObject.orderSn,item)">售后中</button>
                    <button v-else-if="item.statusReturn===2" class="buttonred margin_left"  @click="orderSpeed(dataObject.orderSn,item)">已通过</button>
                    <button v-else-if="item.statusReturn===3" class="buttonred margin_left"  @click="orderSpeed(dataObject.orderSn,item)">已拒绝</button>
                    <button v-else-if="item.statusReturn===4" class="buttonred margin_left"  @click="orderSpeed(dataObject.orderSn,item)">处理中</button>
                    <button v-else-if="item.statusReturn===5" class="buttonred margin_left"  @click="orderSpeed(dataObject.orderSn,item)">已完成</button>
                  </template>
                </div>
              </div>
            </dd>
          </dl>
        </div>
        <div class="orderinfoTopcenterthree">
          <div style="display:flex;justify-content:space-between">
            <div class="orderinfoTopcenterthreepayAmount">
              <span v-if="dataObject.status != 0">实际支付：￥{{dataObject.payAmount }}</span>
              <span v-else>应当支付：￥{{dataObject.payAmount }}</span>
            </div>
            <div style="display:flex; justify-content:space-around;" class="orderinfoTopcenterthreebutton">
              <div v-if="dataObject.status===0">
                <button class="button" @click="orderPay(dataObject.id,dataObject.payAmount,dataObject.autoCancelTime,dataObject)">付款</button>
                <button class="button" @click="orderCancel(dataObject.id)">取消订单</button>
              </div>
              <!-- 订单完成之后无法评论 -->
              <template v-if="dataObject.afterStatus=== 0">
                <template v-if="dataObject.status===1">
                  <button class="button" @click="orderOnego(dataObject)">申请退款</button>
                </template>
                <template v-else-if="dataObject.status===2">
                  <button class="button" @click="wuliu">查看物流</button>
                  <button class="button" @click="orderSure(dataObject.id)">确认收货</button>
                </template>
                <template v-else-if="dataObject.status>1 && dataObject.status<5">
                  <button class="button" @click="wuliu">查看物流</button>
                  <!-- <button class="button" @click="orderdelete(dataObject.id)">删除订单</button> -->
                </template>
              </template>
              <template v-if="dataObject.afterStatus===1">
                <button class="buttonred" @click="orderSpeed(dataObject.orderSn,dataObject)">售后中</button>
              </template>
              <template v-if="dataObject.afterStatus===2">
                <button class="buttonred" @click="orderSpeed(dataObject.orderSn,dataObject)">已通过</button>
              </template>
              <template v-if="dataObject.afterStatus===3">
                <button class="buttonred" @click="orderSpeed(dataObject.orderSn,dataObject)">已拒绝</button>
              </template>
              <template v-if="dataObject.afterStatus===4">
                <button class="buttonred" @click="orderSpeed(dataObject.orderSn,dataObject)">售后完成</button>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="multiplexing"></div>
      <div class="orderinfobottomTop">
        <div style="width:96%;margin:0 auto;">
          <div class="orderinfobottomTopTop">
            <div>订单编号：{{dataObject.orderSn}}</div>
            <div style="padding-left:15px;" class="tag-read" :data-clipboard-text="copyText" @click="copy">复制</div>
          </div>
          <div class="orderinfobottomTopTop">
            创建时间：{{dataObject.createTime  }}
          </div>
        </div>
      </div>
      <div class="multiplexing"></div>
      <div style="width:96%;margin:0 auto;" class="fzmshs">
        <div style="display:flex;justify-content:flex-start;padding-top:10px;">
          <div class="marginFang">支付方式</div>
          <div v-if="dataObject.payType==0">未支付</div>
          <div v-if="dataObject.payType==1">支付宝</div>
          <div v-if="dataObject.payType==2">微信</div>
        </div>
        <div style="display:flex;justify-content:flex-start;">
          <div class="marginFang">商品金额</div>
          <div>￥{{dataObject.totalAmount}}</div>
        </div>
        <div style="display:flex;justify-content:flex-start;">
          <div class="marginFangBu">运费</div>
          <div>￥{{dataObject.freightAmount }}</div>
        </div>
        <div style="display:flex;justify-content:flex-start;">
          <div class="marginFang">折扣金额</div>
          <div>￥{{dataObject.discountAmount}}</div>
        </div>
        <div style="display:flex;justify-content:flex-start;padding-bottom:10px;border-bottom:0.3px solid #ccc;">
          <div class="marginFangBuright">优惠券金额</div>
          <div>￥{{dataObject.couponAmount}}</div>
        </div>
        <div style="display:flex;justify-content:flex-start;color:#B4272D;padding:8px 0px;">
          <div class="marginFangBuleft">
            <span v-if="dataObject.status != 0">实际支付：</span>
            <span v-else>应当支付：</span>
          </div>
          <div>￥{{dataObject.payAmount}}</div>
        </div>
      </div>
      <div class="multiplexing"></div>
      <div style="margin-bottom:10px;">
        <div class="metxal">服务时间：9:00-18:00</div>
        <div class="algsin" @click="Customer">联系客服</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Button, Dialog, Toast } from 'vant'
import { orderInfo, orderReceive, orderCancel, orderdelete } from '../../request/api.js'
import Clipboard from 'clipboard'

export default {
  components: {
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component
  },
  name: 'orderInfo',
  data () {
    return {
      id: '',
      dataObject: {},
      copyText: '',
      orderItemList: {}
    }
  },
  methods: {
    // 删除订单
    orderdelete (id) {
      // var _this = this
      Dialog.confirm({
        message: '是否删除该订单'
      })
        .then(() => {
          orderdelete(id, { id: id }).then(res => {
            console.log(res)
            if (res.code === 200) {
              this.$router.go(-1)
              Toast.success(res.message)
            } else {
              Toast.fail(res.message)
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    // 确认收货
    orderSure (id) {
      // var thisa = this
      // console.log(this.active)
      Dialog.confirm({
        message: '是否确认收货'
      })
        .then(() => {
          orderReceive(id, { id: id }).then(res => {
            console.log(res)
            if (res.code === 200) {
              this.$router.go(0)
            }
          })
        })
        .catch(() => {
        // on cancel
        })
    },
    goCommodityDetails(i) {
      console.log(event)
      console.log(i)
      if (event.target.className !== 'buttonred margin_left' && event.target.className !== 'button margin_left' && event.target.className !== 'button') {
        // this.$router.push(`/CommodityDetails/${i}`)
        // productId
        this.$router.push({ path: '/CommodityDetails', query: { id: i.productId, skuId: i.productSkuId } })
      }
    },
    // 申请退款
    orderOnego(i) {
      console.log(i)
      var orderlist = JSON.stringify(i)
      this.$router.push({ path: '/refund', query: { orderlistdata: orderlist } })
    },
    // 联系客服
    Customer() {
      var _that = this
      if (document.getElementById('YSF-BTN-HOLDER') == null) {
        (function (w, d, n, a, j) {
          w[n] = w[n] || function () {
            (w[n].a = w[n].a || []).push(arguments)
          }
          j = d.createElement('script')
          j.async = true
          j.src = 'https://qiyukf.com/script/25a9d2979b1be1ed8eea4708abb27a06.js'
          d.body.appendChild(j)
        })(window, document, 'ysf')
        window.ysf('onready', function () {
          window.ysf('config', {
            uid: '国电',
            name: '国电' + _that.dataObject.orderSn,
            mobile: _that.dataObject.receiverPhone,
            email: _that.dataObject.receiverAddrNameFull + _that.dataObject.receiverDetailAddress,
            success: function() {
              // todo
              console.log('todo')
            },
            error: function() {
              // handle error
              console.log('handle error')
            }
          })
          window.ysf('product', {
            show: 1, // 1显示 0不显示
            title: _that.dataObject.orderItemList[0].productName,
            desc: _that.dataObject.orderItemList[0].productAttr,
            picture: _that.dataObject.orderItemList[0].productPic,
            note: _that.dataObject.orderItemList[0].productPrice + '元',
            sendByUser: _that.dataObject.orderItemList[0].productPrice.productQuantity,
            success: function() { // 成功回调
              window.ysf('open')
            },
            error: function() { // 错误回调

            }
          })
        })
      } else if (document.getElementById('YSF-BTN-HOLDER').style.display === 'none') {
        document.getElementById('YSF-BTN-HOLDER').style.display = 'block'
      }
    },
    // 取消订单
    orderCancel (id) {
      // const _that = this
      Dialog.confirm({
        message: '是否取消订单'
      })
        .then(() => {
          orderCancel(id, { id: id }).then(res => {
            console.log(res)
            if (res.code === 200) {
              this.$router.go(0)
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    copy() {
      this.$nextTick(() => {
        var clipboard = new Clipboard('.tag-read')
        clipboard.on('success', e => {
          Toast('复制成功')
          // 释放内存
          clipboard.destroy()
        })
        clipboard.on('error', e => {
          // 不支持复制
          Toast('复制成功')
          // 释放内存
          clipboard.destroy()
        })
      })
    },
    // 评价
    orderEval (i, id) {
      console.log(i, id)
      // 跳转路由传递对象参数
      var arr = JSON.stringify(i)
      this.$router.push({ path: '/CommodityEvaluation', query: { content: arr, id: id } })
    },
    wuliu () {
      console.log(this.dataObject)
      this.$router.push({ path: '/orderCourier', query: { sn: this.dataObject.deliverySn, cm: this.dataObject.deliveryCompany } })
    },
    // 支付
    orderPay (id, money, time, i) {
      console.log(id)
      console.log(i.id)
      var data = JSON.parse(sessionStorage.getItem('pay'))
      console.log(data)
      var pay = JSON.stringify({ id: id, money: money, time: time, address: { addrNameFull: i.receiverAddrNameFull, detailAddress: i.receiverDetailAddress, name: i.receiverName, phone: i.receiverPhone } })
      sessionStorage.setItem('pay', pay)
      this.$router.push({ path: '/pay' })
    },
    ConfirmReceipt () {
      Dialog.confirm({
        message: '您确定要确认收货吗'
      }).then(() => {
        // on confirm
      }).catch(() => {
        // on cancel
      })
    },
    // 申请售后
    orderSale(i) {
      console.log(i)
      var data = JSON.stringify(i)
      this.$router.push({ path: '/afterSale', query: { data: data, orderId: i.returnId } })
    },
    orderSpeed(i, ele) {
      console.log(i, ele)
      this.$router.push({ path: '/Speed', query: { id: ele.returnId, orderItemListId: ele.id } })
    }
  },
  beforeDestroy() {
    document.getElementById('YSF-BTN-HOLDER').style.display = 'none'
  },
  created () {
    console.log(this.$route.params.id)
    this.id = this.$route.params.id
    console.log(this.$route.params.id)
    orderInfo(this.id).then(res => {
      console.log(res)
      if (res.code === 200) {
        this.dataObject = res.data
        // console.log(res.data.status > 1 || res.data.status < 5)
        this.orderItemList = res.data.orderItemList[0]
        this.copyText = res.data.orderSn
      }
    })
  }
}
</script>
<style lang="less" scoped>
.margin_left{
  margin-bottom: 20px;
}
.button{
  padding:0px 15px;
  height: 50px;
  border: 0.5px solid #ccc;/*no*/
  background-color: #fff;
  font-size: 26px;
}
.buttonred{
  padding:0px 15px;
  height: 50px;
  border: 0.5px solid #B4272D;/*no*/
  background-color: #fff;
  color: #B4272D;
  font-size: 26px;
  letter-spacing:8px;
}
  .multiplexing{
    height: 24px;
    background-color: #F4F2F0;
  }
  .orderInfoTop {
    width:750px;
    height:154px;
    background:rgba(255,253,238,1);
    .orderinfoTopOne{
      padding-top: 24px;
      font-size: 28px;
      display: flex;
      justify-content: flex-start;
      padding-bottom: 15px;
    }
    .orderinfoTopTwo{
      font-size: 24px;
      width: 632px;
      padding-bottom: 25px;
    }
  }
  .orderinfoTopheard{
    width: 100%;
    height: 100px;
    color:#B4272D;
    div{
      padding-top: 37px;
      text-align: right;
      padding-right: 45px;
    }
  }
  .orderinfoTopcenter{
    width: 96%;
    margin: 0 auto;
    .orderinfoTopcenterone{
      height: 100px;
      border-bottom: 1px solid #EEEEEE;/*no*/
        div{
        padding-top: 37px;
        text-align: right;
        padding-right: 30px;
        color: #B4272D;
      }
    }
    .orderinfoTopcentertwo {
        border-bottom: 0.5px solid #EEEEEE;/*no*/
      dl{
          padding-top: 20px;
          height: 180px;
        dt{
          width: 150px;
          height: 150px;
          img{
            width: 100%;
            height: 100%;
          }
        }
        dd{
          margin-left: 170px;
          .orderinfoTopcentertwodd{
            font-size: 28px;
          }
          .orderinfoTopcentertwoddTwo{
            font-size: 24px;
            color: #999999;
            padding-left: 10px;
            padding-top: 10px;
          }
          .orderinfoTopcentertwoddThree{
            margin-top: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 34px;
            div{
              font-size: 30px;
            }
            s{
              font-size: 27px;
              padding-top: 5px;
            }
            button{
              margin-right: 40px;
            }
          }
        }
      }
    }
    .orderinfoTopcenterthree{
      height: 135px;
      .orderinfoTopcenterthreepayAmount{
        font-size: 26px;
        padding-top: 37px;
      }
      .orderinfoTopcenterthreebutton {
        margin-right: 38px;
        button{
          margin-left: 20px;
          margin-top: 37px;
        }
      }
    }
  }
  .orderinfobottomTop{
    height: 132px;
  }
  .orderinfobottomTopTop{
    margin-top: 28px;
    font-size: 26px;
    display: flex;
    justify-content: flex-start;
  }
  .marginFang {
    margin-right: 100px;
  }
  .marginFangBu {
    margin-right: 152px;
  }
  .marginFangBuleft{
    margin-right: 70px;
  }
  .marginFangBuright{
    margin-right: 75px;
  }
  .ellpis{
    overflow : hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  .ZY{
    color: white;
    padding:2px 12px;
    font-size: 24px;
    border-radius: 5px;
    background-color: #B4272D;
  }
  .tag-read{
    color: #B4272D;
  }
  .fzmshs{
    font-size: 26px;
    div{
      margin-top: 5px;
    }
  }
  .metxal{
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 26px;
  }
  .algsin{
    height: 30px;
    color: #B4272D;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 26px;
  }
</style>
